import { StateCreator } from 'zustand';

import { deepMerge } from '@/utilities/deepMerge';

import { UserPreferenceActions, UserPreferenceState } from '../types';

export const createUserPreferenceActions: StateCreator<
    UserPreferenceState & UserPreferenceActions,
    [['zustand/immer', never]],
    [],
    UserPreferenceActions
> = (set, get, store) => ({
    // Local
    setPreferences: (prefs) => set({ selectedUserPreference: prefs }),
    updateLocal: (updates) =>
        set((state) => {
            state.selectedUserPreference = deepMerge(state.selectedUserPreference ?? {}, updates);
        }),
    // Core
    clearSelectedUserPreference: () => {
        set((state) => {
            state.selectedUserPreference = null;
        });
    },
});
